<!-- UserWithdrawDialog.vue -->
<template>
  <v-dialog :model-value="modelValue" max-width="400px" @update:modelValue="onDialogModelUpdate">
    <v-card>
      <v-card-title class="text-h6">회원 탈퇴 확인</v-card-title>
      <v-card-text>
        정말로 회원 탈퇴를 하시겠습니까? 이 작업은 되돌릴 수 없습니다.
        탈퇴하시면 7일간 재가입할 수 없습니다.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" variant="text" @click="onClose">취소</v-btn>
        <v-btn color="red" variant="text" @click="onConfirmWithdraw">회원 탈퇴</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserWithdrawDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'withdraw'],
  methods: {
    onDialogModelUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    onClose() {
      this.$emit('update:modelValue', false);
    },
    onConfirmWithdraw() {
      this.$emit('withdraw');
      this.$emit('update:modelValue', false);
    },
  },
};
</script>
